export default __webpack_public_path__ + "static/media/13.6ddc24fd.jpg";